document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.site-header');
      
  let prevScrollPos = 0;
    
  window.addEventListener('scroll', function() {
    const currentScrollPos = window.pageYOffset;
    header.classList.add('hc-sticky');
    
    if (currentScrollPos < prevScrollPos) {
      header.classList.add('hc-up');
      header.classList.remove('hc-down');
    }else{
      header.classList.add('hc-down');
      header.classList.remove('hc-up');
    }
    prevScrollPos = currentScrollPos;
    
    if (currentScrollPos === 0) {
      header.classList.remove('hc-sticky');
    }
  });
});

/* SE - SPI adjustments - 05 May '25 */
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(() => {
    const payment = document.querySelector('shopify-payment-terms');
      
    if (payment && payment.shadowRoot) {
      const text = payment.shadowRoot.querySelector('#shopify-installments');
      if (text) {
        const bodyFont = getComputedStyle(document.body).fontFamily;
        text.style.fontFamily = bodyFont;
        observer.disconnect(); // Stop observing once applied
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});